import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const QuestionMarkCircle: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="question mark icon">
      {/* <title>question mark icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7604 3.75C7.38595 3.75 3.84039 7.44329 3.84039 12C3.84039 16.5558 7.38601 20.25 11.7604 20.25C16.1348 20.25 19.6804 16.5558 19.6804 12C19.6804 7.44329 16.1348 3.75 11.7604 3.75ZM2.40039 12C2.40039 6.61487 6.59067 2.25 11.7604 2.25C16.9301 2.25 21.1204 6.61487 21.1204 12C21.1204 17.3841 16.9302 21.75 11.7604 21.75C6.59061 21.75 2.40039 17.3841 2.40039 12Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7093 15.446C12.1069 15.446 12.4293 15.7818 12.4293 16.196V16.2242C12.4293 16.6384 12.1069 16.9742 11.7093 16.9742C11.3116 16.9742 10.9893 16.6384 10.9893 16.2242V16.196C10.9893 15.7818 11.3116 15.446 11.7093 15.446Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93164 10.1933C8.93164 8.45393 10.2749 7.05469 11.9448 7.05469C13.6048 7.05469 14.957 8.45254 14.957 10.1933C14.957 11.4196 14.2829 12.2867 13.4067 12.7914C13.3521 12.8238 13.3001 12.8543 13.2503 12.8835C12.9963 13.0323 12.8017 13.1464 12.6424 13.2956C12.486 13.4422 12.4272 13.5664 12.4293 13.7397C12.4346 14.1539 12.1164 14.4941 11.7188 14.4995C11.3211 14.5049 10.9947 14.1736 10.9895 13.7594C10.9804 13.0415 11.3049 12.5313 11.6793 12.1805C11.9695 11.9084 12.3301 11.6994 12.5806 11.5542C12.6231 11.5296 12.6625 11.5068 12.6977 11.4858L12.7069 11.4804C13.2387 11.1751 13.517 10.7531 13.517 10.1933C13.517 9.28375 12.8122 8.55469 11.9448 8.55469C11.0702 8.55469 10.3716 9.28236 10.3716 10.1933C10.3716 10.6075 10.0492 10.9433 9.65161 10.9433C9.254 10.9433 8.93164 10.6075 8.93164 10.1933Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default QuestionMarkCircle;
